module.exports = __webpack_public_path__ + "media/images/partner/pic_7-20863263f495b0c8735ea7f285c50fc7.png";